import { loginSuccess } from '../actions/authentication';

/**
 * Met à jour les données utilisateur dans le store tout en préservant les permissions
 * @param dispatch - Fonction dispatch du store
 * @param sessionUser - Utilisateur actuel de la session
 * @param updatedData - Nouvelles données utilisateur
 */
export function updateUserPreservingPermissions(dispatch: any, sessionUser: any, updatedData: any) {
  // Fusionner les nouvelles données avec les permissions existantes
  const updatedUser = {
    ...updatedData,
    app_permissions: sessionUser.user?.app_permissions || [] // Conserver les permissions existantes
  };
  
  dispatch(
    loginSuccess({ 
      auth: { ...sessionUser.auth }, 
      user: updatedUser 
    })
  );
  
  return updatedUser;
}
